/* src/app/layout/action-button-toolbar/action-button-toolbar.component.css */
.actions {
  display: inline-block;
}
.action {
  cursor: pointer;
  display: inline-block;
  opacity: 0.4;
  padding-left: 5px;
  padding-right: 5px;
  transition: 0.3s;
}
.red {
  color: black;
  transition: 0.3s;
}
.red:hover {
  opacity: 1 !important;
  color: red;
}
.action:hover {
  opacity: 1;
}
/*# sourceMappingURL=action-button-toolbar.component.css.map */
